import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress, Button, CircularProgress, } from '@mui/material';
import { formatDistanceStrict, differenceInMilliseconds, intervalToDuration, formatDuration } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { withStyles } from '@mui/styles';
import {
  Modal,
  TextField,
} from '@mui/material';
import { addDays, addHours, format } from 'date-fns';
import { ShowError, ShowSucess } from '../../../../../_helper/helper';
import { put } from '../../../../../_helper/api_helper';
import { getFormalApiErrorMessage } from '../../../../../utils/apiError';

const CountdownProgressBar = ({ targetDate, expiryDate, cert, getData }) => {
  const [percentage, setPercentage] = useState(0);
  const [remainingTime, setRemainingTime] = useState('');
  const [elapsedTime, setElapsedTime] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedDays, setSelectedDays] = useState('');
  const [hours, setHours] = useState('');
  const [submitLoader, setSubmitLoader] = useState(false)

  const timeZone = 'Pacific/Guam'; // Chamorro Standard Time

  const baseURL = process.env.REACT_APP_API_DOTNET_URL;


  const addTenDays = (dateString) => {
    let date = new Date(dateString);
    date.setDate(date.getDate() + 10);
    let newDateString = date.toISOString();
    return newDateString
  };

  const isGreaterThan10Days = (start, end) => {
    const millisecondsInDay = 1000 * 60 * 60 * 24;
    const differenceInMs = differenceInMilliseconds(end, start);
    const differenceInDays = differenceInMs / millisecondsInDay;
    return differenceInDays > 10;
  };

  const calculatePercentage = () => {
    const now = utcToZonedTime(new Date(), timeZone);
    const target = new Date(expiryDate);
    const totalDuration = target - now;
    const elapsedDuration = now - new Date(targetDate);

    if (totalDuration <= 0) {
      setPercentage(100);
      setRemainingTime('0d 0h');
      setElapsedTime('Elapsed Time: ' + formatDuration(intervalToDuration({ start: target, end: now }), { format: ['days', 'hours'] }));
      //   if(isGreaterThan10Days(target,now)) setElaspTimeOver(true)
    } else {
      const remainingDuration = intervalToDuration({ start: now, end: target });
      const elapsedDurationObj = intervalToDuration({ start: new Date(targetDate), end: now });

      setRemainingTime('Remaining Time: ' + formatDuration(remainingDuration, { format: ['days', 'hours'] }));
      setElapsedTime('Elapsed Time: ' + formatDuration(elapsedDurationObj, { format: ['days', 'hours'] }));
      //   if(isGreaterThan10Days(new Date(targetDate),now)) setElaspTimeOver(true)
      setPercentage((elapsedDuration / (totalDuration)) * 100);
    }
  };

  useEffect(() => {
    const interval = setInterval(calculatePercentage, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);


  const AnimatedLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: '#ffcccb',
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#1a90ff',
      transition: 'width 1s linear',
    },
  }))(LinearProgress);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDaysChange = (event) => {
    setSelectedDays(event.target.value);
  };

  const handleHoursChange = (event) => {
    setHours(event.target.value);
  };

  const extendDateHandler = async (date) => {
    const payload = {
      certificatioN_PID: cert?.CERTIFICATION_PID?.trim(),
      announcemenT_ID: cert?.ANNOUNCEMENT_ID?.trim(),
      expiry: date,
    }
    setSubmitLoader(true)
    try {
      await put(`${baseURL}/Certification/ExtendCert`, payload);
      ShowSucess("Date Extended Successfully")
      getData()
    } catch (error) {
      ShowError(getFormalApiErrorMessage(error, "Something Went Wrong"))
    } finally {
      setSubmitLoader(false)
      handleClose();
    }
  }

  const handleSubmit = () => {
    const currentDate = new Date(expiryDate);
    const newDate = addDays(addHours(currentDate, Number(hours)), Number(selectedDays));
    const formattedDate = format(newDate, "yyyy-MM-dd'T'HH:mm:ss.SS");
    console.log(`New Date: ${formattedDate}`, selectedDays, hours, currentDate);
    extendDateHandler(formattedDate)
    // Handle the submit logic here
  };

  return (
    <Box display="flex" flexDirection="column" width="100%">
      {/* <Typography variant="h6">Countdown to {targetDate}</Typography>
      <Typography variant="body1">{remainingTime}</Typography> */}
      <Typography variant="body2" textAlign="end">
        <Button
          size="small"
          variant="outlined"
          style={{ marginBottom: "4px" }}
          onClick={handleOpen}
        >
          Extend
        </Button>
      </Typography>
      <Box mt={0} width="100%">
        <AnimatedLinearProgress variant="determinate" value={percentage} />
      </Box>
      <Box display="flex" justifyContent="space-between" width="100%" mb={1}>
        <Box display="flex" gap={1} alignItems="center">
          <Box
            width={10}
            height={10}
            bgcolor="#1a90ff"
            borderRadius="50%"
            mb={0}
          />
          <Typography variant="body2">{elapsedTime}</Typography>
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          <Box
            width={10}
            height={10}
            bgcolor="#ffcccb"
            borderRadius="50%"
            mb={0}
          />
          <Typography variant="body2">{remainingTime}</Typography>
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Typography id="modal-title" variant="h6" component="h2">
            Extend expiration date
          </Typography>
          <Typography variant="body2">{remainingTime}</Typography>
          <TextField
            id="select-days"
            label="Days"
            type="number"
            value={selectedDays}
            onChange={handleDaysChange}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <TextField
            id="select-hours"
            label="Hours"
            type="number"
            value={hours}
            onChange={handleHoursChange}
            inputProps={{ min: 0 }}
            fullWidth
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              gap: "8px",
              mt: 2,
            }}
          >
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={submitLoader}
            >
              {submitLoader ? <CircularProgress size={18} /> : "Submit"}
            </Button>
            <Button
              variant="outlined"
              onClick={handleClose}
              disabled={submitLoader}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default CountdownProgressBar;
